<template>
  <div v-if="pageTotal >= 0" class="ms-pagination flex-row flex-between">
    <div v-if="customTotalPaging" class="d-flex total-count" v-html="customTotalPaging" />
    <div v-else class="d-flex total-count">
      <div class="total-label">
        {{ $t('i18nComponent.Paging.Total') }}
      </div>
      <div class="total">
        {{
          pageTotal
            ? $ms.format.formatData(pageTotal, {
              formatType: $ms.constant.FormatType.Number,
            })
            : 0
        }}
        <span class="text">{{ $t('i18nComponent.Paging.RecordPaging') }}</span>
      </div>
      <slot name="customTotal" />
    </div>

    <!-- Combo số trang và next-prev trang -->

    <div class="flex" />
    <div v-if="isShowRightFooter" class="pagination-sticky">
      <!-- <div style="color: #5f6368">
        {{ $t('i18nComponent.Paging.PageSize') }}
      </div>
      <menu-wrapper class="widget-more-container">
        <template #menu-button="{ toggleMenu }">
          <div @click="toggleMenu" class="page-size icon24">
            {{ pageSizeValue }}
          </div>
        </template>
        <template #menu-content>
          <menu-item
            v-for="item in pageSizes"
            :key="item"
            @menu-item-click="changePageSize(item)"
            >{{ item }}</menu-item
          >
        </template>
      </menu-wrapper> -->

      <!-- <ms-combobox-enum
        class="mr-2 border-color-list"
        enum="Pagination"
        :initText="
          $ms.format.formatData(pageSizeValue, {
            formatType: $ms.constant.FormatType.Enum,
            enumName: 'Pagination',
          })
        "
        @selected="selectedChangePageSize"
      ></ms-combobox-enum> -->
      <div class="min-page-caption">
        Số bản ghi/trang
      </div>
      <div class="page-size">
        <ms-combobox
          value-field="value"
          display-field="text"
          :data="pageSizeSource"
          :model-value="pageSizeValueObject"
          :select-only="true"
          :has-border="true"
          @selected="selectedChangePageSize"
        />
      </div>
      <div class="from-to flex-center">
        {{
          $t('i18nCommon.Paging.ToAndFrom', {
            fromIndex: fromIndex,
            toIndex: toIndex,
          })
        }}
      </div>
      <div class="flex-center">
        <div
          class="move prev"
          :class="{ disabled: disablePrevPage }"
          @click="previousPage"
        />
        <div
          class="move next"
          :class="{ disabled: disableNextPage }"
          @click="nextPage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default {
  name: 'MsPagination',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    pageSize: {
      type: Number,
    },
    isShowRightFooter: {
      default: true,
      type: Boolean,
    },
    dataRender: {
      default: 0,
      type: Number,
    },
    /**
     * Tổng số bản ghi của dữ liệu
     */
    pageTotal: {
      default: 0,
      type: Number,
    },
    /*
    Cho phép xem tổng số
    Create: DVQUAN 21/05/2020
    */
    summary: {
      default: null,
      type: Object,
    },
    pageIndex: {
      default: 1,
      type: Number,
    },
    pagingTemplate: {},
    data: {},
    useServerSide: {
      default: false,
      type: Boolean,
    },
    /**
     * Custom tổng số bản ghi
     */
    customTotalPaging: {
      type: String,
      default: ''
    }
  },

  data() {
    let me = this;
    return {
      viewPage: me.pageIndex,
      currentPage: me.pageIndex,
      pageSizeValueObject: [
        {
          value: me.pageSize,
          text: String(me.pageSize),
        }
      ],
    };
  },
  
  computed: {
    //Kiểm tra hiện thị ... đầu tiên
    //Created by LTDAT (01/04/2020)

    checkFirstDotted() {
      const listFirst = [1, 2];
      return (
        this.totalPages > 4 &&
        listFirst.indexOf(this.viewPage) < 0 &&
        this.viewPage > 2
      );
    },
    //Kiểm tra hiện thị dấu ... thứ 2
    //Created by LTDAT (01/04/2020)

    checkSecondDotted() {
      return this.totalPages > 4 && this.viewPage <= this.totalPages - 3;
    },
    /**
     * index của bản ghi cuối cùng trong trang trên tập dữ liệu trong DB
     */
    toNumberRecord() {
      return (this.pageIndex - 1) * this.pageSizeValueObject[0].value + this.dataRender;
    },

    /**
     * Tổng số trang theo pageSize hiện tại của grid
     */
    totalPages() {
      return Math.ceil(this.pageTotal / this.pageSizeValueObject[0].value);
    },

    /**
     * Bản ghi bắt đầu
     */
    fromIndex() {
      return this.dataRender == 0
        ? 0
        : (this.pageIndex - 1) * this.pageSizeValueObject[0].value + 1;
    },
    /**
     * Bản ghi bắt đầu
     */
    toIndex() {
      let value = (this.pageIndex - 1) * this.pageSizeValueObject[0].value + this.dataRender;
      return Math.min(value, this.pageTotal);
    },

    disableNextPage() {
      if (this.pageIndex >= this.totalPages && !this.useServerSide) {
        return true;
      }
      return false;
    },
    disablePrevPage() {
      if (this.pageIndex <= 1) {
        return true;
      }
      return false;
    },
    isShowQuantity() {
      return (
        this.summary &&
        this.summary.hasOwnProperty(this.quantityProp) &&
        !this.summary.isHideQuantity
      );
    },
    isShowAmount() {
      return (
        this.summary &&
        this.summary.hasOwnProperty(this.amountProp) &&
        !this.summary.isHideAmount
      );
    },
  },
  watch: {
    pageSizeValueObject: {
      handler(newVal, oldVal) {
        this.$emit('changePageSize', newVal[0].value);
      },
      deep: true,
    },
    // Sau khi gán pagesize cần gán lại value cho pageSizeValue (đang không nhận giá trị thay đổi truyền xuống)
    pageSize: {
      handler(newVal, oldVal) {
        this.pageSizeValueObject[0].value = newVal;
        this.pageSizeValueObject[0].text = String(newVal);
      },
    },
  },

  created() {
    const me = this;
    me.initPageSize();
  },
  beforeUnmount() {
    const me = this;
    if (me.summary) {
      Object.clear.call(null, me.summary);
    }
  },

  methods: {
    initPageSize() {
      this.pageSizes = [10, 20, 50, 100];
      let sizes = [10, 20, 50, 100],
        arr = [];
      for (let i = 0; i < sizes.length; i++) {
        let value = sizes[i];
        arr.push({
          value: value,
          text: String(value),
        });
      }
      this.pageSizeSource = arr;
    },

    //Load lại page theo số trang.
    loadPageIndex(index) {
      let me = this;
      let payload = {
        skip: (index - 1) * me.pageSizeValueObject[0].value,
        take: me.pageSizeValueObject[0].value,
      };
      me.$emit('loadData', payload);
    },

    nextPage() {
      let me = this;
      if (!me.disableNextPage) {
        me.loadPageIndex(this.pageIndex + 1);
      }
    },

    firstPage() {
      let me = this;
      if (!me.disablePrevPage) {
        me.loadPageIndex(1);
      }
    },

    lastPage() {
      let me = this;
      if (!me.disableNextPage) {
        me.loadPageIndex(me.totalPages);
      }
    },

    previousPage() {
      let me = this;
      if (!me.disablePrevPage) {
        me.loadPageIndex(this.pageIndex - 1);
      }
    },

    changePageSize(value) {
      this.pageSizeValueObject[0].value = value;
      this.pageSizeValueObject[0].text = String(value);
      this.loadPageIndex(1);
    },

    selectedChangePageSize({ newData }) {
      if (newData) {
        this.changePageSize(newData[0].value);
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsPagination.scss';
@import '@/assets/scss/function.scss';
.ms-pagination {
  font-size: 14px;

}

.page-size {
  // border: 1px solid var(--secondary);
  border-radius: 4px;
}
// .ms-combobox-tree-multiple .ms-combobox-tree-multiple-main{
//   border: 1px solid var(--secondary)!important;
// }
</style>
